<template lang="pug">
  .giftcard-validator
    RogueInput(
      ref="addCardInput"
      :disabled="loading"
      label="Gift Card Number"
      name="code"
      :placeholder="__('Enter your Gift Card code here')"
      v-model="code"
    )
    span.block.field-error(v-if="showInlineErrors && error") {{ error }}
    RogueButton(
      v-if="giftCardPage"
      :disabled="!code"
      width="full"
      color="red"
      :giftCardPage="true"
      :loading="loading"
      @click="getBalance()"
    ) {{ __(buttonText) }}
    RogueButton(
      v-else
      :disabled="!code"
      :loading="loading"
      @click="getBalance()"
    ) {{ __(buttonText) }}
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'
import { useRogue } from '@/js/services/Rogue'

const props = withDefaults(defineProps<{
  buttonText? : string
  clearOnSubmit? : boolean
  showInlineErrors?: boolean
  giftCardPage? : boolean
}>(), {
  buttonText       : 'Check Balance',
  clearOnSubmit    : true,
  showInlineErrors : false,
  giftCardPage     : false,
})

const emit = defineEmits<{
  onValidGiftcard: [value: { code: string; balance: number }]
  onError: [error: unknown]
}>()

const rogue = useRogue()
const addCardInput = useTemplateRef<{ blur: boolean }>('addCardInput')

const loading = ref(false)
const code = ref('')
const error = ref<string | null>(null)

async function getBalance() {
  loading.value = true
  code.value = code.value.trim()
  error.value = null

  try {
    const resp = await rogue.fetchWithCaptcha(
      '/svc_gc/validate',
      'POST',
      { code: code.value },
      {},
      'json',
      'gcvalidate'
    ) as { balance: number }

    const balance = resp.balance

    if (balance) {
      emit('onValidGiftcard', { code: code.value, balance })

      if (props.clearOnSubmit) {
        code.value = ''
        if (addCardInput.value) {
          addCardInput.value.blur = false
        }
      }
    } else {
      emit('onError', 'The card you entered has no balance')
    }
  } catch (e) {
    emit('onError', e)
    error.value = rogue.__('Invalid gift card number. Please try again.')
  }

  loading.value = false
}
</script>
